import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Wrench, Shield, Droplets, PaintBucket, Zap, HardHat, Truck, Headphones, BadgeCheck } from 'lucide-react';
import { products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
export function Home() {
  const featuredProducts = products.filter(p => p.isHot).slice(0, 4);
  const allProducts = products.slice(0, 8);
  const categories = [{
    name: 'Herramientas',
    icon: Wrench,
    link: '/catalogo?cat=herramientas'
  }, {
    name: 'Cerrajería',
    icon: Shield,
    link: '/catalogo?cat=cerrajeria'
  }, {
    name: 'Plomería',
    icon: Droplets,
    link: '/catalogo?cat=plomeria'
  }, {
    name: 'Pintura',
    icon: PaintBucket,
    link: '/catalogo?cat=pintura'
  }, {
    name: 'Electricidad',
    icon: Zap,
    link: '/catalogo?cat=electricidad'
  }, {
    name: 'Construcción',
    icon: HardHat,
    link: '/catalogo?cat=construccion'
  }];
  return <div className="bg-[#f8f9fa]" data-id="element-457">
      {/* Hero Banner */}
      <section className="relative bg-gradient-to-r from-[#0056b3] to-[#003d82] text-white" data-id="element-458">
        <div className="max-w-7xl mx-auto px-4 py-12 md:py-20" data-id="element-459">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-460">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-461">
              <span className="inline-block bg-white/20 text-white text-sm font-medium px-3 py-1 rounded-full mb-4" data-id="element-462">
                ¡Nuevos productos disponibles!
              </span>
              <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-463">
                Todo para tu hogar y construcción
              </h1>
              <p className="text-lg text-blue-100 mb-6 max-w-lg" data-id="element-464">
                Herramientas profesionales, cerrajería de calidad y materiales
                de construcción al mejor precio en Caracas.
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-465">
                <Link to="/catalogo" className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#0056b3] font-semibold rounded-md hover:bg-gray-100 transition-colors" data-id="element-466">
                  Ver Catálogo
                  <ArrowRight className="w-4 h-4" data-id="element-467" />
                </Link>
                <Link to="/contacto" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white/10 transition-colors" data-id="element-468">
                  Contáctanos
                </Link>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="hidden md:block" data-id="element-469">
              <img src="https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&q=80&w=800" alt="Herramientas" className="rounded-lg shadow-2xl" data-id="element-470" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefits Bar */}
      <section className="bg-white border-b" data-id="element-471">
        <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-472">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-473">
            <div className="flex items-center gap-3 justify-center md:justify-start" data-id="element-474">
              <Truck className="w-8 h-8 text-[#0056b3]" data-id="element-475" />
              <div data-id="element-476">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-477">
                  Envío a todo el país
                </p>
                <p className="text-xs text-gray-500" data-id="element-478">Gratis en compras +$500</p>
              </div>
            </div>
            <div className="flex items-center gap-3 justify-center" data-id="element-479">
              <BadgeCheck className="w-8 h-8 text-[#0056b3]" data-id="element-480" />
              <div data-id="element-481">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-482">
                  Garantía de calidad
                </p>
                <p className="text-xs text-gray-500" data-id="element-483">Productos originales</p>
              </div>
            </div>
            <div className="flex items-center gap-3 justify-center md:justify-end" data-id="element-484">
              <Headphones className="w-8 h-8 text-[#0056b3]" data-id="element-485" />
              <div data-id="element-486">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-487">
                  Asesoría técnica
                </p>
                <p className="text-xs text-gray-500" data-id="element-488">Expertos a tu servicio</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-12" data-id="element-489">
        <div className="max-w-7xl mx-auto px-4" data-id="element-490">
          <div className="flex justify-between items-center mb-8" data-id="element-491">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-492">Categorías</h2>
            <Link to="/catalogo" className="text-[#0056b3] text-sm font-medium hover:underline flex items-center gap-1" data-id="element-493">
              Ver todas <ArrowRight className="w-4 h-4" data-id="element-494" />
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-495">
            {categories.map(cat => <Link key={cat.name} to={cat.link} className="group bg-white rounded-lg p-4 text-center hover:shadow-md transition-all border border-gray-100" data-id="element-496">
                <div className="w-16 h-16 mx-auto mb-3 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-[#0056b3] transition-colors" data-id="element-497">
                  <cat.icon className="w-8 h-8 text-[#0056b3] group-hover:text-white transition-colors" data-id="element-498" />
                </div>
                <span className="text-sm font-medium text-gray-700 group-hover:text-[#0056b3]" data-id="element-499">
                  {cat.name}
                </span>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-12 bg-white" data-id="element-500">
        <div className="max-w-7xl mx-auto px-4" data-id="element-501">
          <div className="flex justify-between items-center mb-8" data-id="element-502">
            <div data-id="element-503">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-504">
                Ofertas Destacadas
              </h2>
              <p className="text-gray-500 text-sm mt-1" data-id="element-505">
                Los mejores precios en productos seleccionados
              </p>
            </div>
            <Link to="/catalogo" className="text-[#0056b3] text-sm font-medium hover:underline flex items-center gap-1" data-id="element-506">
              Ver todos <ArrowRight className="w-4 h-4" data-id="element-507" />
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-508">
            {featuredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-509" />)}
          </div>
        </div>
      </section>

      {/* All Products */}
      <section className="py-12" data-id="element-510">
        <div className="max-w-7xl mx-auto px-4" data-id="element-511">
          <div className="flex justify-between items-center mb-8" data-id="element-512">
            <div data-id="element-513">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-514">Productos</h2>
              <p className="text-gray-500 text-sm mt-1" data-id="element-515">
                Explora nuestro catálogo completo
              </p>
            </div>
            <Link to="/catalogo" className="text-[#0056b3] text-sm font-medium hover:underline flex items-center gap-1" data-id="element-516">
              Ver catálogo completo <ArrowRight className="w-4 h-4" data-id="element-517" />
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-518">
            {allProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-519" />)}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-12 bg-white" data-id="element-520">
        <div className="max-w-7xl mx-auto px-4" data-id="element-521">
          <div className="bg-[#0056b3] rounded-xl p-8 md:p-12 text-center text-white" data-id="element-522">
            <h2 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-523">
              ¿Necesitas ayuda con tu proyecto?
            </h2>
            <p className="text-blue-100 mb-6 max-w-xl mx-auto" data-id="element-524">
              Nuestro equipo de expertos está listo para asesorarte. Contáctanos
              y recibe atención personalizada.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-525">
              <Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#0056b3] font-semibold rounded-md hover:bg-gray-100 transition-colors" data-id="element-526">
                <Headphones className="w-5 h-5" data-id="element-527" />
                Contactar Asesor
              </Link>
              <a href="tel:+584124279146" className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white/10 transition-colors" data-id="element-528">
                +58 412-4279146
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}